module.exports = __webpack_public_path__ + "static/media/10.e11b3900.JPG";